import { IconProps } from "../../utils/global-types/global-types";

const LeftArrowIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className}
    {...rest}
  >
    <g clipPath="url(#clip0_4124_52888)">
      <path
        fill="currentColor"
        d="M3.192 8.534 7.525 4.2a.65.65 0 0 1 .465-.191c.176 0 .34.068.464.191l.394.394a.665.665 0 0 1 0 .934L6.32 8.062h8.032a.64.64 0 0 1 .648.646v.556c0 .362-.286.675-.648.675H6.29l2.557 2.547a.647.647 0 0 1 0 .922l-.394.393a.65.65 0 0 1-.464.191.65.65 0 0 1-.465-.192L3.192 9.466A.65.65 0 0 1 3 9.001c0-.177.068-.343.192-.467"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_4124_52888">
        <path fill="#fff" d="M0 0h18v18H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default LeftArrowIcon;
